import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { ETeam } from "cresus-common";
import TextCardComponent from "./TextCardComponent";
function getColorToText(team) {
    switch (team) {
        case ETeam.RED:
            return "#DD2810";
        case ETeam.BLUE:
            return "rgba(16, 110, 221, 1)";
        case ETeam.GREEN:
            return "rgba(36, 189, 79, 1)";
        case ETeam.YELLOW:
            return "rgba(255, 213, 63, 1)";
        case ETeam.NONE:
            return "rgba(0,0,0,1)";
    }
}
function ChatMessageComponent(props) {
    const isPlayer = props.message.person.name !== undefined;
    const isMyMessage = props.message.person.name === props.myPlayerName;
    const isAnimator = props.message.person.animatorName !== undefined;
    const animName = props.message.person.animatorName
        ? props.message.person.animatorName + " - "
        : "";
    const animatorName = props.message.person.isCoanimator
        ? "Coanimateur"
        : animName + "Animateur";
    const messageName = isPlayer
        ? props.message.person.name
        : animatorName;
    return (_jsxs("div", Object.assign({ className: "flex font-kalam flex-col" }, { children: [!isMyMessage && (_jsxs(_Fragment, { children: [!props.grouped && (_jsx("div", Object.assign({ className: "flex mt-2", style: {
                            fontWeight: 700,
                            color: getColorToText(props.message.person.team),
                        } }, { children: messageName }))), _jsx("div", Object.assign({ className: "flex", style: {
                            color: "#666",
                        } }, { children: _jsx(TextCardComponent, { text: props.message.content }) }))] })), isMyMessage && (_jsxs(_Fragment, { children: [!props.grouped && (_jsx("div", Object.assign({ className: "flex self-end mt-2", style: {
                            fontWeight: 700,
                            color: getColorToText(props.message.person.team),
                        } }, { children: messageName }))), _jsx("div", Object.assign({ className: "flex self-end", style: {
                            color: "#000",
                        } }, { children: _jsx(TextCardComponent, { text: props.message.content }) }))] }))] })));
}
export default ChatMessageComponent;
